import { render, staticRenderFns } from "./ApiGateway.vue?vue&type=template&id=2ec05692&scoped=true"
import script from "./ApiGateway.vue?vue&type=script&lang=ts"
export * from "./ApiGateway.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec05692",
  null
  
)

export default component.exports